var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxPlus = function Svg18PxPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#56565C",
    d: "M14.75 9.75H3.25a.75.75 0 0 1 0-1.5h11.5a.75.75 0 0 1 0 1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#56565C",
    d: "M9 15.5a.75.75 0 0 1-.75-.75V3.25a.75.75 0 0 1 1.5 0v11.5a.75.75 0 0 1-.75.75"
  })));
};
export default Svg18PxPlus;